import styled from '@emotion/styled';
import { Loader } from '@hotjar/hotsauce';

export const AppContainer = styled.div`
  height: 100vh;
`;

export const AppContent = styled.div`
  // This is to compensate for the header height
  height: 100%;
`;

export const AppLoader = styled(Loader)`
  height: 100vh;
`;
